import { useTheme } from '@mui/material'
import { memo } from 'react'

import brandLogoDark from 'assets/logo-dark.png'
import brandLogoLight from 'assets/logo-light.png'
import { THEME_MODE } from '../../../constants/theme'
import LogoContainer from './logoContainer'

const Logo = ({ ...restProps }) => {
  const theme = useTheme()
  return (
    <LogoContainer
      src={
        theme.palette.mode === THEME_MODE.DARK ? brandLogoDark : brandLogoLight
      }
      sx={{ width: 200 }}
      {...restProps}
    />
  )
}

export default memo(Logo)
